export default __webpack_public_path__ + "static/media/57_mobile.68228fa9.jpg";